import React from 'react'

const Interest = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      fill={props.fill || '#1A344F'}
      fillRule="nonzero"
      d="M21.991 2.833a.236.236 0 010-.075.899.899 0 00-.075-.258v-.058a1.095 1.095 0 00-.174-.192l-.091-.083-.042-.042-.116-.05h-.1L21.16 2h-.074a.975.975 0 00-.291.075L2.517 11.241a.834.834 0 00.166 1.591l5.94 1.483-.756 6.75a.835.835 0 00.374.833c.14.076.299.111.457.1a.757.757 0 00.424-.117l3.905-2.383 1.661 2.142a.83.83 0 00.657.358h.15a.832.832 0 00.68-.583l5.816-18.332a.873.873 0 000-.25zm-16.724 8.9L16.35 6.165 9.296 12.74l-4.029-1.009zm4.445 7.849l.415-3.792 1.894 2.417-2.31 1.375zm5.317-.184l-4.378-5.65 8.756-8.157-4.378 13.807z"
    />
  </svg>
)

export default Interest
